import React, { useEffect, useState, useCallback, useRef } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { toast } from 'react-toastify';
import { getSessionId } from '../utils/sessionId';
import Calculator from './Calculator';
import { cashToSend } from '../utils/cashTender';
import LoyaltyPoints from './LoyaltyPoints';
import { useNavigate } from 'react-router-dom';
import AddSelectCustomerModal from './modals/AddSelectCustomerModal';
import ApplyVoucherModal from './modals/ApplyVoucherModal';
import ApplyDiscountModal from './modals/ApplyDiscountModal';
import { useConnection } from '../offline/connection';
import { canDo } from '../offline/state';
import { keptBillNotice, offlineRefusal } from '../offline/text';
import { buildPrintBillPayload } from '../utils/printBillPayload';
import { buildTotals } from '../utils/customerDisplay';
import {
  BACKOFF_MS,
  addPendingTomPayment,
  refOfRecord,
  tomLog,
  findPending,
  submitPendingTomPayment,
} from '../utils/tomPayments';
import TomPaymentDialog from './modals/TomPaymentDialog';
import ScanButton from './ScanButton';
import useScannedVoucher from '../hooks/useScannedVoucher';
import useScannedMember from '../hooks/useScannedMember';

export default function CheckoutSummary({
  PAYMENT_MODES,
  orderTypeNum,
  orderId,
  tableId = null,
  resumingUnpaidOrder = false,
  selectedOffer,
  paymentMethod,
  setPaymentMethod,
  selectedTender,
  selectedCartItems = [],
  onEftposRequest = () => { },
  onPaymentSuccess,
  onPaymentComplete = null,
  onBillingConfigChange = null,
  onDigitalReceiptConfigChange = null,
  onSummaryReady = null,
  splitPaymentActive = false,
  setUuid,
  setAmount,
  splitType,
  splitCount,
  cashAmount,
  cashEftposMode = false,
  setSplitPaymentActive,
  setSplitType,
  setSplitCount,
  setFreezeSplitControls,
  isPrepaid,
  orderName,
  onDisplayTotalsChange = null
}) {
  const navigate = useNavigate();
  // Offline, only what the offline engine says it can do is offered (a no-op online / with no engine).
  const { state: offlineState } = useConnection();
  const [checkoutSummary, setCheckoutSummary] = useState(null);
  // offline, a table opened before the outage shows the copy of its bill the device kept: say as of when ({ time, stale, text, staleText } or null)
  const [keptBill, setKeptBill] = useState(null);
  const [loading, setLoading] = useState(false);
  const [offerId, setOfferId] = useState(null);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [loyaltyApplied, setLoyaltyApplied] = useState(false);
  const [loyaltyAmount, setLoyaltyAmount] = useState(0);
  // Customer screen only (never sent to the server): points the cashier ticked, and which offer id
  // came from a typed voucher code, so the second screen can label it as a voucher.
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [appliedVoucher, setAppliedVoucher] = useState(null);
  const [coupon, setCoupon] = useState('');
  const [couponApplying, setCouponApplying] = useState(false);
  const [couponMessage, setCouponMessage] = useState('');
  const [showVoucherModal, setShowVoucherModal] = useState(false);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // A manual discount and an Offer/voucher are mutually exclusive - applying one clears the
  // other, the same implicit exclusivity Promotion and Coupon already have by sharing offerId.
  const [manualDiscountType, setManualDiscountType] = useState(null);
  const [manualDiscountValue, setManualDiscountValue] = useState(null);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [gratuitySurchargeId, setGratuitySurchargeId] = useState(null);
  const gratuitySurchargeIdRef = useRef(null);
  const hasAutoSelectedGratuity = useRef(false);
  useEffect(() => {
    gratuitySurchargeIdRef.current = gratuitySurchargeId;
  }, [gratuitySurchargeId]);

  // Default Gratuity to selected so staff opt OUT if the customer doesn't
  // want it, rather than having to opt in. Only auto-select once, so it
  // doesn't override a staff member's explicit choice to deselect it later.
  useEffect(() => {
    if (hasAutoSelectedGratuity.current) return;
    const firstGratuityOption = checkoutSummary?.gratuity_surcharges?.[0];
    if (firstGratuityOption) {
      hasAutoSelectedGratuity.current = true;
      setGratuitySurchargeId(firstGratuityOption.id);
    }
  }, [checkoutSummary?.gratuity_surcharges]);

  const restaurantName = localStorage.getItem("restaurant_name");

  const showPayTom =
    ["Demo Restaurant", "Napoli Restaurant"].includes(restaurantName);

  useEffect(() => {
    setOfferId(selectedOffer?.id || null);
    if (selectedOffer?.id) {
      setManualDiscountType(null);
      setManualDiscountValue(null);
    }
  }, [selectedOffer]);

  const nativeLog = (msg) => {
    window.AndroidPOS?.logWeb?.(msg);
  };

  const handleTomPayment = async () => {
    // The terminal approval has to be recorded on the server afterwards, which the offline engine
    // cannot do (it answers 501), so never start one while offline.
    if (!canDo(offlineState, 'cardPayments')) {
      toast.error('Card payments through the terminal need an internet connection.');
      return;
    }
    try {
      nativeLog("WEB_PAYMENT_CLICKED");
      const res = await callAPI(
        apiUrls.TOM_INITIATE,
        {},
        "POST",
        {
          order_id: orderId,
          table_id: tableId
        }
      );
      const sessionId = res?.data?.data?.session_id;
      nativeLog("SESSION_ID_RECEIVED: " + sessionId);
      console.log("eftposssee",sessionId);
        if (!sessionId) {
          
        toast.error("Failed to initiate payment");
        return;
      }
      nativeLog("API_TOM_INITIATE_CALLED");
      // what the customer is asked to pay, kept for the "approved but not recorded" messages
      tomAmountRef.current = checkoutSummary?.net_total ? Number(checkoutSummary.net_total) : null;
      window.AndroidPOS?.startPayment(
        checkoutSummary?.net_total
          ? Math.round(checkoutSummary.net_total * 100)
          : 0,
        sessionId 
      );
    } catch (err) {
      console.error(err);
      toast.error("Payment initiation failed");
    }
  };

  const downloadTomReport = () => {
    window.AndroidPOS?.downloadTomDebugReport?.();
  };


  // Tap on Mobile approvals the POS could not record yet (see utils/tomPayments.js).
  const [tomIssue, setTomIssue] = useState(null); // { id, message }
  const [tomBusy, setTomBusy] = useState(false);
  const tomAmountRef = useRef(null);
  const tomTimerRef = useRef(null);
  const tomAutoStepRef = useRef(0);
  const tomMountedRef = useRef(true);
  // The Worldline callback is registered once, so everything it reads must come from here (the
  // props it would otherwise close over are the ones from the first render, before the order id
  // had been resolved).
  const tomLatestRef = useRef({});

  useEffect(() => {
    tomMountedRef.current = true;
    return () => {
      tomMountedRef.current = false;
      clearTimeout(tomTimerRef.current);
    };
  }, []);

  const attemptTomRecord = async (id, { manual = false } = {}) => {
    clearTimeout(tomTimerRef.current);
    if (tomMountedRef.current) setTomBusy(true);
    const result = await submitPendingTomPayment(id, { manual });
    if (!tomMountedRef.current) return;
    setTomBusy(false);
    const latest = tomLatestRef.current;

    if (result.outcome === 'recorded') {
      setTomIssue(null);
      const res = result.response;
      toast.success(res?.data?.message || 'Payment successful');
      toast.success('Order marked as paid');
      const apiActionRedirect = res?.data?.action === 'redirect';
      const allPaid =
        res?.data?.data?.all_item_paid === true ||
        res?.data?.all_item_paid === true;
      if (apiActionRedirect || allPaid) {
        latest.navigate('/dashboard');
      } else {
        latest.onPaymentSuccess?.();
        await latest.fetchCheckoutSummary();
      }
      return;
    }
    if (result.outcome === 'already_paid') {
      setTomIssue(null);
      toast.success('The card payment was already recorded for this order');
      latest.navigate('/dashboard');
      return;
    }
    if (result.outcome === 'busy') return;
    if (result.outcome === 'missing') {
      setTomIssue(null);
      return;
    }

    // rejected / ambiguous / unverified: keep the dialog up. Network-type failures are retried by
    // themselves a few times (2 s, 5 s, 10 s); a refusal from the server is not.
    setTomIssue({ id, message: result.message || 'The payment could not be recorded.' });
    tomLog('TOM_DIALOG shown');
    if (!manual && result.outcome !== 'rejected' && tomAutoStepRef.current < BACKOFF_MS.length) {
      const delay = BACKOFF_MS[tomAutoStepRef.current];
      tomAutoStepRef.current += 1;
      tomTimerRef.current = setTimeout(() => attemptTomRecord(id), delay);
    }
  };

  useEffect(() => {
    window.onWorldlinePaymentResult = async (response) => {
    //  alert("Payment callback received");
      console.log("RAW RESPONSE:", response);
      nativeLog("PAYMENT_CALLBACK_RECEIVED_RAW_RESPONSE"+response);
  
      try {
  
        const data =
          typeof response === "string"
            ? JSON.parse(response)
            : response;
  
        console.log("PARSED RESPONSE:", data);
  
        nativeLog("PARSED_RESPONSE: " + JSON.stringify(data));
       // alert(JSON.stringify(data, null, 2));
  
        if (
          data?.isoResponseCode === "00" ||
          data?.result === "WPI_RESULT_SUCCESS"
        ) {
  
          toast.success("Payment Successful");
  
          console.log("SUCCESS RESPONSE:", data);

          const latest = tomLatestRef.current;
          const orderNumber = Array.isArray(latest.checkoutSummary?.order_number)
            ? latest.checkoutSummary.order_number.join(' ')
            : latest.checkoutSummary?.order_number;
          // Debug report: the ids this callback will post with (the stale-closure bug showed up here as null/null)
          tomLog(
            `TOM_CB order_id=${latest.orderId ?? 'null'} table_id=${latest.tableId ?? 'null'} amount=${data?.authorizedAmount ?? data?.amount ?? 'n/a'} ref=${data?.paymentSolutionReference || data?.reference || 'n/a'}`
          );
          // Store the approval BEFORE calling the server: the customer has been charged.
          const { record, duplicate } = addPendingTomPayment({
            orderId: latest.orderId,
            tableId: latest.tableId,
            orderNumber,
            amount: tomAmountRef.current ?? latest.checkoutSummary?.net_total,
            tomResponse: data,
            payload: {
              order_id: latest.orderId,
              table_id: latest.tableId,
              payment_mode: PAYMENT_MODES.eftpos,
              paid: 1,
              tom_response: data,
              pos_type: "TapOnMobile",
              resuming_unpaid_order: latest.resumingUnpaidOrder ? 1 : 0,
              ...(gratuitySurchargeIdRef.current ? { gratuity_surcharge_id: gratuitySurchargeIdRef.current } : {})
            },
          });
          tomLog(`TOM_PENDING ${duplicate ? 'exists' : 'saved'} id=${refOfRecord(record)}`);
          tomAutoStepRef.current = 0;
          await attemptTomRecord(record.id);
          return;
        }
  
    
        if (data?.result === "WPI_RESULT_FAILURE") {
  
          const msg =
            data?.remark ||
            data?.errorCondition ||
            "Payment Failed";
  
          toast.error(msg);
  
          console.log("FAILURE RESPONSE:", data);
  
          return;
        }
        toast.error("Unknown payment response");
        console.log("UNKNOWN RESPONSE:", data);
  
      } catch (e) {
        console.error("Payment Parse Error:", e);
        toast.error("Invalid payment response");
      }
    };
  
    return () => {
      delete window.onWorldlinePaymentResult;
    };
  
  }, []);

  useEffect(() => {
    setOfferId(null);
    setAppliedVoucher(null);
    setCoupon('');
    setCouponMessage('');
    setManualDiscountType(null);
    setManualDiscountValue(null);
    // Gratuity is intentionally left as-is on payment method change - staff
    // unselect it manually if needed, it shouldn't reset automatically.
  }, [paymentMethod]);

  useEffect(() => {
    const resumeLinklyPayment = async () => {
      if (!orderId && !tableId) return;
  
      try {
        const payload = {};
        if (orderId) payload.order_id = orderId;
        if (tableId) payload.table_id = tableId;
  
        // withLoader=false - this is a background check for an in-progress
        // payment to resume, not a core piece of the checkout page itself.
        const res = await callAPI(
          apiUrls.CHECK_LAST_LINKLY_PAYMENT,
          {},
          'POST',
          payload,
          {},
          {},
          false
        );
  
        const linkly = res?.data;
  
        
        if (linkly?.status === 1 && linkly?.uuid) {
          window.dispatchEvent(
            new CustomEvent('eftpos-payment-linkly', {
              detail: {
                uuid: linkly.uuid,
                amount: linkly.amount
              }
            })
          );
  
          setUuid(linkly.uuid);
          setAmount(linkly.amount);
  
          toast.info('Resuming EFTPOS payment');
        }
      } catch (err) {
        console.error('Linkly resume failed', err);
      }
    };
  
    
    if (checkoutSummary?.linkly?.length > 0) {
      resumeLinklyPayment();
    }
  
    // keyed on how many terminal payments are listed, not on the list itself: every summary reload hands
    // back a new array, which re-ran this check (another request) even when nothing had changed
  }, [orderId, tableId, checkoutSummary?.linkly?.length]);

const fetchCheckoutSummary = useCallback(async () => {
  setLoading(true);

  try {
    const payload = {
      payment_method: paymentMethod ?? PAYMENT_MODES.cod,
      session_id: getSessionId(),
      loyalty_applied: loyaltyApplied,
      loyalty_amount: loyaltyAmount
    };

    if (selectedTender) payload.tender = selectedTender;
    if (offerId) payload.offer_id = offerId;
    if (manualDiscountType && manualDiscountValue) {
      payload.manual_discount_type = manualDiscountType;
      payload.manual_discount_value = manualDiscountValue;
    }
    // "Redeem loyalty points" ticked: the server prices the member's points in (one tap uses what the order can take); never on a split payment
    if (loyaltyApplied && !splitPaymentActive) payload.loyalty_redeem = 1;
    if (orderId) payload.order_id = orderId;
    if (gratuitySurchargeId) payload.gratuity_surcharge_id = gratuitySurchargeId;
    if (selectedCartItems.length > 0)
      payload.selecteditem = selectedCartItems.join(',');

    if (splitPaymentActive) {
      // "Cash + EFTPOS" has no backend concept of its own - it's a 2-way equal split with a
      // staff-entered (not equal) first amount, so the wire payload always says 'equal' here.
      // See the same translation in handlePayment()'s payload below.
      payload.split_type = splitType === "cash_eftpos" ? "equal" : splitType;

      if (splitType === "equal" && splitCount > 0) {
        payload.split_count = splitCount;
      } else if (splitType === "cash_eftpos") {
        payload.split_count = 2;
      }
    }

    let url = apiUrls.CHECKOUT_SUMMARY_DETAILS;
    if (tableId) url += `?table_id=${tableId}`;
    else if (orderId) url += `?order_id=${orderId}`;

    const res = await callAPI(url, {}, "POST", payload);
    setKeptBill(keptBillNotice(res?.headers));

    const rawSummary = res?.data?.data;
    if (!rawSummary) return;


    let summary = { ...rawSummary };


    if (Array.isArray(summary.split_payment)) {
      summary.split_payment = null;
    }

    if (typeof summary.order_number === "string") {
      summary.order_number = summary.order_number.split(" ");
    }

    setCheckoutSummary(summary);
    if (onBillingConfigChange) onBillingConfigChange(!!summary.pos_billing_print_prompt);
    if (onDigitalReceiptConfigChange) onDigitalReceiptConfigChange(!!summary.pos_digital_receipt_enabled);
    if (onSummaryReady) onSummaryReady(summary);

    const backendSplit = summary.split_payment;

    const hasRealSplitStarted =
      backendSplit &&
      backendSplit.history &&
      backendSplit.history.some(
        (sp) => Number(sp.payment_amount) > 0
      );

    if (hasRealSplitStarted) {
      setSplitPaymentActive(true);
      
      if (backendSplit.split_type) {
        setSplitType(backendSplit.split_type);
      }

      if (backendSplit.split_count) {
        setSplitCount(backendSplit.split_count);
      }
      setFreezeSplitControls(true);
    } else {
      setFreezeSplitControls(false);
    }

    window.dispatchEvent(
      new CustomEvent("total-due-amount", {
        detail: {
          total: summary.net_total,
          order_type: summary.order_type
        }
      })
    );

  } catch (err) {
    console.error(err);
    toast.error(offlineRefusal(err) || "Failed to fetch checkout summary");
  } finally {
    setLoading(false);
  }
}, [
  paymentMethod,
  selectedTender,
  offerId,
  manualDiscountType,
  manualDiscountValue,
  orderId,
  tableId,
  selectedCartItems,
  loyaltyApplied,
  loyaltyAmount,
  splitPaymentActive,
  splitType,
  splitCount,
  gratuitySurchargeId
]);
  tomLatestRef.current = {
    orderId,
    tableId,
    resumingUnpaidOrder,
    checkoutSummary,
    navigate,
    onPaymentSuccess,
    fetchCheckoutSummary,
  };
  useEffect(() => {
    //paymentMethodn if null, don't fetch summary yet, wait for the real value to be set
    // Wait for the real value instead of racing it.
    if (paymentMethod == null) return;
    fetchCheckoutSummary();
  }, [fetchCheckoutSummary, paymentMethod]);

  // `codeOverride` lets a scanned voucher apply straight away (state would not have updated yet)
  const handleApplyCoupon = async (codeOverride) => {
    const code = typeof codeOverride === 'string' ? codeOverride : coupon;
    //if (checkoutSummary?.split_payment?.current) {
    if (hasSplitPayment) { 
      toast.error('Cannot apply coupon during split payment');
      return;
    }

    if (!code) {
      toast.error('Please add a coupon');
      return;
    }

    setCouponApplying(true);
    try {
      const payload = {
        voucher: code,
        payment_method: paymentMethod,
      };

      if (tableId) payload.table_id = tableId;
      else if (orderId) payload.order_id = orderId;

      const res = await callAPI(
        apiUrls.VOUCHER_VALIDITY,
        {},
        'POST',
        payload
      );

      if (!res?.data?.valid) {
        toast.error('Invalid coupon');
        return;
      }

      
      setOfferId(res.data.valid.id);
      setAppliedVoucher({ code, offerId: res.data.valid.id });
      setCouponMessage(res.data.valid.message || 'Coupon applied');
      // Mutually exclusive with a manual discount - a voucher replaces it, not stacks with it.
      setManualDiscountType(null);
      setManualDiscountValue(null);

      setLoyaltyApplied(false);
      setLoyaltyAmount(0);

      toast.success('Coupon applied');
      setShowVoucherModal(false);
      fetchCheckoutSummary();

    } catch (err) {
      console.error(err);
      toast.error('Coupon validation failed');
    } finally {
      setCouponApplying(false);
    }
  };

  // A membership card scanned at checkout is mapped to this order like any customer (the cashier then ticks "Redeem loyalty points").
  const [loyaltyKey, setLoyaltyKey] = useState(0);
  useScannedMember({
    orderNumbers: checkoutSummary?.order_number?.join(','),
    busy: paymentProcessing,
    onAttached: () => {
      setLoyaltyKey((k) => k + 1); // the points box asks again, for the new customer
      setLoyaltyApplied(false);
      setLoyaltyAmount(0);
      setLoyaltyPoints(0);
      fetchCheckoutSummary();
    },
  });

  // A voucher scanned from the checkout page itself (no popup open) is applied straight away.
  useScannedVoucher({
    enabled: canDo(offlineState, 'vouchers'),
    modalOpen: showVoucherModal,
    busy: paymentProcessing || couponApplying,
    onVoucher: (code) => {
      setCoupon(code);
      handleApplyCoupon(code);
    },
  });

  const handleApplyManualDiscount = (type, value) => {
    if (hasSplitPayment) {
      toast.error('Cannot apply discount during split payment');
      return;
    }

    // Mutually exclusive with Promotion/Coupon - clear those so only one discount source is active.
    setOfferId(null);
    setCoupon('');
    setCouponMessage('');

    setManualDiscountType(type);
    setManualDiscountValue(value);

    toast.success('Discount applied');
    setShowDiscountModal(false);
    fetchCheckoutSummary();
  };

  const allItemPaid = checkoutSummary?.all_item_paid === true;
  const showCalculator = paymentMethod === PAYMENT_MODES.cod;
  const showPayNow = paymentMethod !== PAYMENT_MODES.eftpos && !allItemPaid;
  const showEftposButtons =
  paymentMethod === PAYMENT_MODES.eftpos &&
  checkoutSummary?.linkly?.length > 0 &&
  canDo(offlineState, 'cardPayments') &&
  !allItemPaid;
  const showUnpaid = !allItemPaid && orderTypeNum !== 3;
  const showCompleteOrder = allItemPaid;
  // const hasSplitPayment = checkoutSummary?.split_payment &&
  //   (checkoutSummary.split_payment.history?.length > 0 || checkoutSummary.split_payment.current);
  // Before the first "Cash + EFTPOS" payment, the backend has nothing persisted yet and would
  // otherwise show an equal-share preview (since the wire payload already says split_type:
  // 'equal', split_count: 2 - see fetchCheckoutSummary) that doesn't match the cash amount staff
  // are about to type - the cash_eftpos preview block below is what shows instead. Once the first
  // payment lands, fetchCheckoutSummary's split_type sync flips local splitType to 'equal' (what
  // the backend actually persisted), so this exclusion stops applying and the real Paid/Paying
  // Now amounts render via the existing equal-split UI below.
  const hasSplitPayment = splitType !== 'cash_eftpos' && checkoutSummary?.split_payment &&
    (
      (checkoutSummary.split_payment.history?.some(sp => Number(sp.payment_amount) > 0)) ||
      (checkoutSummary.split_payment.current?.total_amonut > 0)
    );

  const perSplitAmount =
    checkoutSummary?.split_payment?.current?.total_amonut || 0;

  // What the customer is paying right now: the whole bill, or just this part of a split. The cash calculator works against this, and the
  // server works the change out against the same amount, so the change on the screen is the change on the printed bill.
  const payingNow = splitPaymentActive && splitType === 'cash_eftpos'
    ? (Number(cashAmount) || 0)
    : (splitPaymentActive && perSplitAmount > 0 ? perSplitAmount : (Number(checkoutSummary?.net_total) || 0));
  // The cash handed over, as entered on the calculator (0 when none): sent with a cash payment so the paid bill can print it.
  const cashTenderedRef = useRef(0);
  const [calculatorReset, setCalculatorReset] = useState(0);

  const splitsPaidCount = checkoutSummary?.split_payment?.history?.length || 0;
  const totalSplitPaid = (checkoutSummary?.split_payment?.history || [])
    .reduce((sum, sp) => sum + (Number(sp.payment_amount) || 0), 0);
  // Customer (second) screen: re-send the totals whenever the summary, voucher, loyalty tick or
  // split changes. Only wired when the payment screen passes a callback (i.e. a wrapper with the
  // bridge is present).
  const dueNowForDisplay = hasSplitPayment && perSplitAmount > 0 ? perSplitAmount : null;
  const displayVoucher = appliedVoucher && appliedVoucher.offerId === offerId ? appliedVoucher : null;
  useEffect(() => {
    if (!onDisplayTotalsChange || !checkoutSummary) return;
    onDisplayTotalsChange(
      buildTotals(checkoutSummary, {
        voucher: displayVoucher,
        loyaltyPoints: loyaltyApplied ? loyaltyPoints : 0,
        dueNow: dueNowForDisplay,
      })
    );
  }, [onDisplayTotalsChange, checkoutSummary, displayVoucher, loyaltyApplied, loyaltyPoints, dueNowForDisplay]);

  const splitRemainingBalance = Math.max(
    0,
    (Number(checkoutSummary?.net_total) || 0) - totalSplitPaid
  );

  // "Cash + EFTPOS" locks which tender each of its two splits uses (that's the whole point of
  // the mode), so staff shouldn't have to remember to switch the payment-method button
  // themselves between the two: the first split is always cash, the second always EFTPOS.
  useEffect(() => {
    if (!splitPaymentActive || !cashEftposMode || !setPaymentMethod) return;
    setPaymentMethod(splitsPaidCount >= 1 ? PAYMENT_MODES.eftpos : PAYMENT_MODES.cod);
  }, [splitPaymentActive, cashEftposMode, splitsPaidCount, setPaymentMethod, PAYMENT_MODES]);

  const handleEftposPay = async (pinpad) => {
   // if (checkoutSummary?.split_payment?.current && selectedCartItems.length === 0) {
    if (hasSplitPayment && selectedCartItems.length === 0) {
      toast.warning('Please select items for split payment');
      return;
    }
  
    try {
      setPaymentProcessing(true);
      
      window.dispatchEvent(
        new CustomEvent('eftpos-payment-linkly', {
          detail: {
            uuid: null,
            amount: checkoutSummary?.net_total || 0,
            loading: true
          }
        })
      );

        const payload = {
        payment_mode: PAYMENT_MODES.eftpos,
        order_id: orderId,
        table_id: tableId,
        tender: selectedTender,
        pinpad_id: pinpad.id,
        paid:1,
        windcave_id: pinpad.id,
        resuming_unpaid_order: resumingUnpaidOrder ? 1 : 0,
        // Same field handlePayment() sends - without it the backend finds no offer on this
        // request and (unless a prior payment attempt on this same order already persisted
        // offer_id) charges the terminal full price instead of the Promotions discount shown
        // on screen.
        offer_id: offerId,
      };
      if (isPrepaid) {
        payload.isPrepaid = 1;
      }
      if (gratuitySurchargeId) {
        payload.gratuity_surcharge_id = gratuitySurchargeId;
      }
        // split logic
      if (selectedCartItems?.length > 0) {
        payload.payable_cart_items = JSON.stringify(selectedCartItems);
      }
  
      if (splitPaymentActive) {
        payload.split_type = splitType;
  
        if (splitType === "equal") {
          payload.split_count = splitCount;
          payload.split_amount = perSplitAmount;
        }
      }
  
      const url = splitPaymentActive
        ? apiUrls.CART_ORDER_PAYMENT
        : apiUrls.ORDER_PAYMENT;
  
      const res = await callAPI(url, {}, 'POST', payload);
      const data = res?.data;
        if (data?.action === 'redirect') {
        window.location.href = '/home';
        return;
      }
      if (data?.status == 0) {
        window.dispatchEvent(
          new CustomEvent('eftpos-payment-linkly', {
            detail: {
              error: data?.message || 'EFTPOS failed'
            }
          })
        );
        return;
      }
      if (data?.status == 1 || data?.code == 202) {
        if (data?.data?.uuid) {
          window.dispatchEvent(
            new CustomEvent('eftpos-payment-linkly', {
              detail: {
                uuid: data.data.uuid,
                amount: checkoutSummary?.net_total
              }
            })
          );
          return;
        }
      
        if (data?.cart_payment_id) {
          toast.success(data.message || 'Payment successful');
          onPaymentSuccess?.();
          window.dispatchEvent(
            new CustomEvent('eftpos-payment-result', {
              detail: {
                status: 'success',
                message: data?.message
              }
            })
          );  
          return;
        }
      }
      
      
      
      toast.error(data?.message || 'EFTPOS failed');
  
    } catch (err) {
      console.error(err);
      toast.error('EFTPOS error');
    } finally {
      setPaymentProcessing(false);
    }
  };


  const handlePayment = async (paid,manualeftpos = false) => {
    if (!paymentMethod) {
      toast.error('Please select a payment method');
      return;
    }
 
    if (splitPaymentActive) {
      const cashAmountNum = Number(cashAmount);
      if (
        (splitType === "item" && selectedCartItems.length === 0) ||
        (splitType === "equal" && perSplitAmount <= 0) ||
        (splitType === "cash_eftpos" && (
          !cashAmount || cashAmountNum <= 0 || cashAmountNum >= (checkoutSummary?.net_total || 0)
        ))
      ) {
        toast.warning(
          splitType === "item"
            ? "Split payment is enabled. Please select item(s)."
            : splitType === "cash_eftpos"
              ? "Enter a cash amount greater than $0 and less than the total."
              : "Split payment is enabled. Amount must be greater than 0."
        );
        return;
      }
    }
    setPaymentProcessing(true);
    try {
      const payload = {
        payment_mode: manualeftpos ? PAYMENT_MODES.eftpos : paymentMethod,
        paid,
        offer_id: offerId,
     //   payable_cart_items: JSON.stringify(selectedCartItems),
        order_id: orderId,
        table_id: tableId,
        tender: selectedTender,
        manual_eftpos: manualeftpos ? 1 : 0,
        resuming_unpaid_order: resumingUnpaidOrder ? 1 : 0,
      };
      if (manualDiscountType && manualDiscountValue) {
        payload.manual_discount_type = manualDiscountType;
        payload.manual_discount_value = manualDiscountValue;
      }
      // the member's points are used only when this sale is paid, never on a split payment or when the order is left unpaid
      if (loyaltyApplied && !splitPaymentActive && paid) {
        payload.loyalty_redeem = 1;
      }
      if (gratuitySurchargeId) {
        payload.gratuity_surcharge_id = gratuitySurchargeId;
      }
      if (isPrepaid) {
        payload.isPrepaid = 1;
      }
      const cashGiven = cashToSend({ isCash: !manualeftpos && paymentMethod === PAYMENT_MODES.cod, paid, tendered: cashTenderedRef.current });
      if (cashGiven) {
        payload.cash_tendered = cashGiven;
      }
      if (selectedCartItems && Array.isArray(selectedCartItems) && selectedCartItems.length > 0) {
        payload.payable_cart_items = JSON.stringify(selectedCartItems);
      }
      if (splitPaymentActive) {
        // "Cash + EFTPOS" only exists as a wire concept for the very first payment - by the
        // second payment, fetchCheckoutSummary's split_type sync (see hasRealSplitStarted below)
        // has already flipped local splitType to 'equal' once the backend persists it, so this
        // branch only ever runs once per order.
        if (splitType === "cash_eftpos") {
          payload.split_type = "equal";
          payload.split_count = 2;
          payload.split_amount = Number(cashAmount);
        } else {
          payload.split_type = splitType;

          if (splitType == "equal") {
            payload.split_count = splitCount;
            payload.split_amount = perSplitAmount;
          }
        }
      }
      console.log("FINAL PAYLOAD >>>", payload);

      //const url = selectedCartItems.length > 0 ? apiUrls.CART_ORDER_PAYMENT : apiUrls.ORDER_PAYMENT;
      const url = splitPaymentActive ? apiUrls.CART_ORDER_PAYMENT : apiUrls.ORDER_PAYMENT;
      const res = await callAPI(url, {}, 'POST', payload);



      if (paymentMethod === PAYMENT_MODES.eftpos && res?.data?.data?.uuid) {
        window.dispatchEvent(new CustomEvent('eftpos-payment-linkly', {
          detail: { uuid: res.data.data.uuid, amount: res.data.data.amount }
        }));
        return;
      }

      if (
        paymentMethod === PAYMENT_MODES.online &&
        res?.data?.data?.redirect_url
      ) {
        window.location.href = res.data.data.redirect_url;
        return;
      }

      if (res?.data?.status === 1) {
        toast.success(res.data.message || 'Payment successful');
        const apiActionRedirect = res?.data?.action === 'redirect';
        const allPaid =
          res?.data?.data?.all_item_paid === true ||
          res?.data?.all_item_paid === true;

        if (apiActionRedirect || allPaid) {
          onPaymentComplete ? onPaymentComplete(!!checkoutSummary?.pos_billing_print_prompt) : navigate('/dashboard');
        } else {
          // Next part of a split: start the calculator again
          setCalculatorReset((k) => k + 1);
          onPaymentSuccess();
          await fetchCheckoutSummary();
        }
        return;
      } else {
        toast.error(res?.data?.message || 'Payment failed');
      }
    } catch (err) {
      console.error(err);
      toast.error(offlineRefusal(err) || 'Payment failed');
    } finally {
      setPaymentProcessing(false);
    }
  };


  const handlePrintBill = async () => {
    try {
      // the same total the payment will charge: the tip AND the manual discount applied on this screen (held in the page until payment)
      const payload = buildPrintBillPayload({ orderId, tableId, paymentMethod, gratuitySurchargeId, manualDiscountType, manualDiscountValue });
      await callAPI(apiUrls.PRINT_BILL, {}, 'POST', payload);
      toast.success('Bill printed');
    } catch {
      toast.error('Print failed');
    }
  };


  const OrderInfo = () => (
    <>
      <div className="sbRow">
        <span className="lbl">Order #</span>
        <span className="val" style={{ display: "flex", flexWrap: "wrap" }}>{checkoutSummary?.order_number?.map((n, i) => <span key={i} className="me-1">{n}</span>)}</span>
      </div>
      {checkoutSummary?.table?.name && (
        <div className="sbRow">
          <span className="lbl">{checkoutSummary.table.is_pager ? 'Pager #' : 'Table Name #'}</span>
          <span className="val">{checkoutSummary.table.name}</span>
        </div>
      )}
      <div className="sbRow flex-nowrap">
        <span className="lbl">Customer</span>
        <span className="val d-inline-flex flex-wrap gap-2 align-items-center">{orderName || checkoutSummary?.customer_name || 'Guest'}
          <svg width="20" height="20" class="customerEditIcon d-block" onClick={() => setShowCustomerModal(true)}>
            <use xlinkHref="./images/sprite.svg#iconEdit"></use>
          </svg>
        </span>
      </div>
      <div className="sbRow"><span className="lbl">Subtotal</span><span className="val">${checkoutSummary?.gross_total}</span></div>
      
      {checkoutSummary?.loyalty_discount > 0 && (
        <div className="sbRow">
          <span className="lbl">Loyalty Discount</span>
          <span className="val text-danger">- ${checkoutSummary.loyalty_discount}</span>
        </div>
      )}
      {checkoutSummary?.global_surcharges?.map((s, i) => (
        <div key={i} className="sbRow">
          <span className="lbl">{s.charge_name}</span>
          <span className="val">{s.total_expenses}</span>
        </div>
      ))}
      {checkoutSummary?.delivery_fee > 0 && (
        <div className="sbRow">
          <span className="lbl">
            Delivery Fee
            {checkoutSummary?.delivery_distance > 0 && (
              <small className="d-block text-muted">
                ({checkoutSummary.delivery_distance / 1000} kms)
              </small>
            )}
          </span>
          <span className="val">${checkoutSummary.delivery_fee}</span>
        </div>
      )}

      {checkoutSummary?.offer_discount > 0 && (
        <div className="sbRow">
          <span className="lbl">Promo ({checkoutSummary.offer_name})</span>
          <span className="val text-danger">- ${checkoutSummary.offer_discount}</span>
        </div>
      )}
      {checkoutSummary?.manual_discount > 0 && (
        <div className="sbRow">
          <span className="lbl">
            Manual Discount ({checkoutSummary.manual_discount_type === 'percent'
              ? `${checkoutSummary.manual_discount_value}%`
              : `$${checkoutSummary.manual_discount_value}`})
            {' '}
            <button
              type="button"
              className="btn btn-link p-0"
              style={{ fontSize: '0.75rem' }}
              onClick={() => {
                setManualDiscountType(null);
                setManualDiscountValue(null);
              }}
            >
              Remove
            </button>
          </span>
          <span className="val text-danger">- ${checkoutSummary.manual_discount}</span>
        </div>
      )}
      <hr />
      <div className="sbRow flex-nowrap mdText">
        <span className="lbl primaryColor fw-semibold">Total</span>
        <span className="val">${checkoutSummary?.net_total}</span>
      </div>
    </>
  );

  const SplitPayments = () => (
    hasSplitPayment ? (
      <>
        <hr />
        <div className="pSplitCol">
          <h4 className="xsTitle mb-2 pb-0">Split Payments Details</h4>

          {/* Equal split: one unified, ordered list — every split's status (Paid / Paying Now /
              Pending) is visible at a glance instead of scattered across separate blocks. */}
          {splitType === 'equal' && splitCount > 0 && (
            <div className="equalSplitSelection">
              {Array.from({ length: splitCount }).map((_, i) => {
                const paidEntry = checkoutSummary.split_payment.history?.[i];
                const isPaid = !!paidEntry;
                const isActive = !isPaid && i === splitsPaidCount;
                const amount = isPaid ? paidEntry.payment_amount : perSplitAmount;
                const status = isPaid ? 'paid' : isActive ? 'active' : 'pending';

                return (
                  <div key={i} className={`splitStatusRow ${status}`}>
                    <span className="splitStatusLabel">
                      <span className={`splitStatusBadge ${status}`}>
                        {isPaid ? 'Paid' : isActive ? 'Paying Now' : 'Pending'}
                      </span>
                      <span>
                        {cashEftposMode && splitCount === 2
                          ? (i === 0 ? 'Cash' : 'EFTPOS')
                          : `Split ${i + 1}`}
                      </span>
                    </span>
                    <span className="splitStatusAmount">
                      {checkoutSummary.split_payment.currency}
                      {amount}
                    </span>
                  </div>
                );
              })}
            </div>
          )}

          {/* Item-based split: same paid-history + current-due data as before, just with the
              same Paid / Paying Now labeling for consistency with the equal-split view above. */}
          {splitType !== 'equal' && checkoutSummary.split_payment?.history?.filter(sp => sp.payment_amount > 0).map((sp, i) => (
            <React.Fragment key={i}>
              <hr />
              <div className="splitPaid">
                <div className="sbRow flex-nowrap xsTitle">
                  <span className="lbl">
                    <span className="splitStatusBadge paid">Paid</span>
                    <span>Split {i + 1}</span>
                  </span>
                  <span className="val">
                    {checkoutSummary.split_payment.currency}
                    {sp.payment_amount}
                  </span>
                </div>

                {(Array.isArray(sp.surcharge)
                  ? sp.surcharge
                  : Array.isArray(sp.surcharges)
                  ? sp.surcharges
                  : []
                ).map((s, idx) => (
                  s.surchargeAmountIncluded > 0 && (
                    <div key={idx} className="sbRow flex-nowrap xsTitle">
                      <span className="lbl xsLightText">{s.charge_name}</span>
                      <span className="val">
                        {checkoutSummary.split_payment.currency}
                        {s.surchargeAmountIncluded}
                      </span>
                    </div>
                  )
                ))}
              </div>
            </React.Fragment>
          ))}

          {splitType !== 'equal' && checkoutSummary.split_payment.current?.total_amonut > 0 && (
            <>
              <hr />
              <div className="splitPaid pb-2">
                <div className="sbRow flex-nowrap xsTitle">
                  <span className="lbl">
                    <span className="splitStatusBadge active">Paying Now</span>
                    <span>Current Split</span>
                  </span>
                  <span className="val">
                    {checkoutSummary.split_payment.currency}
                    {checkoutSummary.split_payment.current.total_amonut}
                  </span>
                </div>

                {checkoutSummary.split_payment.current.surcharges?.map((s, i) => (
                  s.surchargeAmountIncluded > 0 && (
                    <div key={i} className="sbRow flex-nowrap xsTitle">
                      <span className="lbl xsLightText">{s.charge_name}</span>
                      <span className="val">
                        {checkoutSummary.split_payment.currency}
                        {s.surchargeAmountIncluded}
                      </span>
                    </div>
                  )
                ))}
              </div>
            </>
          )}

          <hr />
          <div className="splitTotalsSummary">
            <div className="sbRow flex-nowrap xsTitle">
              <span className="lbl">Total Paid</span>
              <span className="val successColor">
                {checkoutSummary.split_payment.currency}
                {totalSplitPaid.toFixed(2)}
              </span>
            </div>
            <div className="sbRow flex-nowrap xsTitle pb-3">
              <span className="lbl fw-semibold">Remaining Balance</span>
              <span className="val fw-semibold">
                {checkoutSummary.split_payment.currency}
                {splitRemainingBalance.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </>
    ) : null
  );


  const PaymentButtons = () => {
    const isEftpos = paymentMethod === PAYMENT_MODES.eftpos;

    return (
    <div className="d-flex flex-column gap-2 mt-3">
      {showEftposButtons && checkoutSummary.linkly.map(pinpad => (
        <button key={pinpad.id} className="btn btn-success" onClick={() => handleEftposPay(pinpad)} disabled={paymentProcessing}>
          {pinpad.pinpad_name}
        </button>
      ))}
      {showPayNow && <button className="btn btn-success" onClick={() => handlePayment(1)} disabled={paymentProcessing}>Pay Now</button>}
      {isEftpos && (
        <button
          className="btn btn-warning"
          onClick={() => handlePayment(1, true)}
          disabled={paymentProcessing}
        >
          Manual EFTPOS
        </button>
      )}
      {showUnpaid && <button className="btn btnPrimary" onClick={() => handlePayment(0)} disabled={paymentProcessing}>Unpaid</button>}
      {showCompleteOrder && <button className="btn btn-success" onClick={() => handlePayment(1)} disabled={paymentProcessing}>Complete Order</button>}
      {canDo(offlineState, 'printing') && <button className="btn btnPrimary" onClick={handlePrintBill}>Print Bill</button>}
      {showPayTom && (
        <>
        {canDo(offlineState, 'cardPayments') && (
        <button
            className="btn btn-danger"
            onClick={handleTomPayment}
          >
            Pay on Tom
          </button>
        )}

        <button onClick={downloadTomReport}>
        Download TOM Debug Report
        </button>
        </>
      )}
    </div>
    );
  };

  return (
    <div className="col-lg position-relative">
      {loading && <div className="wave-overlay show" />}
      <div className="cardStyle checkoutSummaryCol">
        <div className="cardHeader"><h4 className="smTitle mb-0">Checkout Summary</h4></div>
        <div className="cardBody">
          <div className="d-flex flex-column gap-3">
            {keptBill && (
              <div className={`alert ${keptBill.stale ? 'alert-warning' : 'alert-info'} mb-0`} role="status" data-testid="kept-bill-notice">
                <div>{keptBill.text}</div>
                {keptBill.stale && <div className="fw-semibold">{keptBill.staleText}</div>}
              </div>
            )}
            <OrderInfo />
            <SplitPayments />
            {splitPaymentActive && splitType === 'cash_eftpos' && (
              <>
                <hr />
                <div className="pSplitCol">
                  <h4 className="xsTitle mb-2 pb-0">Split Payments Details</h4>
                  <div className="equalSplitSelection">
                    <div className="splitStatusRow active">
                      <span className="splitStatusLabel">
                        <span className="splitStatusBadge active">Paying Now</span>
                        <span>Cash</span>
                      </span>
                      <span className="splitStatusAmount">
                        ${cashAmount || '0.00'}
                      </span>
                    </div>
                    <div className="splitStatusRow pending">
                      <span className="splitStatusLabel">
                        <span className="splitStatusBadge pending">Pending</span>
                        <span>EFTPOS</span>
                      </span>
                      <span className="splitStatusAmount">
                        ${Math.max(0, (Number(checkoutSummary?.net_total) || 0) - (Number(cashAmount) || 0)).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
            {showCalculator && <Calculator due={payingNow} resetSignal={calculatorReset} onTenderedChange={(n) => { cashTenderedRef.current = n; }} />}
            <div className="row g-2 couponFldCol">
              {canDo(offlineState, 'vouchers') && (
              <div className="col-auto">
                <button
                  type="button"
                  className="btn btnPrimary"
                  onClick={() => setShowVoucherModal(true)}
                  disabled={paymentProcessing}
                >
                  Apply Voucher
                </button>
              </div>
              )}
              {canDo(offlineState, 'vouchers') && (
              <div className="col-auto">
                {/* starts the camera scanner; the code comes back through ScanListener -> useScannedVoucher. Not shown without a scanner. */}
                <ScanButton />
              </div>
              )}
              {canDo(offlineState, 'discounts') && (
              <div className="col-auto">
                <button
                  type="button"
                  className="btn btnPrimary"
                  onClick={() => setShowDiscountModal(true)}
                  disabled={paymentProcessing}
                >
                  Apply Discount
                </button>
              </div>
              )}

              {couponMessage && (
                <div className="col-12">
                  <small className="text-primary">{couponMessage}</small>
                </div>
              )}
            </div>

            <ApplyVoucherModal
              isOpen={showVoucherModal}
              onClose={() => setShowVoucherModal(false)}
              coupon={coupon}
              onCouponChange={setCoupon}
              onApply={handleApplyCoupon}
              applying={couponApplying}
              message={couponMessage}
            />

            <ApplyDiscountModal
              isOpen={showDiscountModal}
              onClose={() => setShowDiscountModal(false)}
              onApply={handleApplyManualDiscount}
              applying={false}
            />

            {checkoutSummary?.gratuity_surcharges?.length > 0 && (
              <div className="cardLgCol">
                <h4 className="lgTitle">Add Gratuity</h4>
                <select
                  className="form-select"
                  value={gratuitySurchargeId || ''}
                  disabled={paymentProcessing}
                  onChange={(e) => setGratuitySurchargeId(e.target.value || null)}
                >
                  <option value="">None</option>
                  {checkoutSummary.gratuity_surcharges.map((g) => (
                    <option key={g.id} value={g.id}>
                      {g.charge_name} (${g.total_expenses})
                    </option>
                  ))}
                </select>
              </div>
            )}

            {canDo(offlineState, 'discounts') && (
            <LoyaltyPoints key={loyaltyKey} orderId={orderId} tableId={tableId} offer={checkoutSummary?.loyalty} onSelect={(amount, points) => {
              setLoyaltyApplied(amount > 0);
              setLoyaltyAmount(amount);
              setLoyaltyPoints(amount > 0 ? Number(points) || 0 : 0);
            }} />
            )}
            <PaymentButtons />
          </div>
        </div>
      </div>

      <TomPaymentDialog
        isOpen={!!tomIssue}
        record={tomIssue ? findPending(tomIssue.id) : null}
        message={tomIssue?.message}
        busy={tomBusy}
        onRetry={() => tomIssue && attemptTomRecord(tomIssue.id, { manual: true })}
        onClose={() => {
          clearTimeout(tomTimerRef.current);
          setTomIssue(null);
        }}
      />

      <AddSelectCustomerModal
        isOpen={showCustomerModal}
        onClose={() => setShowCustomerModal(false)}
        orderNumbers={checkoutSummary?.order_number?.join(',')}
        orderType={orderTypeNum}
        onCustomerUpdated={() => {
          fetchCheckoutSummary();
        }}
      />

    </div>
  );
}
